export default __webpack_public_path__ + "static/media/analytics-marketing-team-1.0e0c81fc.svg";